export const iconFontAwesomePunctuationSymbolsCircleExclamation = (
	<i className="fa-solid fa-circle-exclamation"></i>
);
